import { render, staticRenderFns } from "./GetCopyForm.vue?vue&type=template&id=519ab3db&scoped=true&"
import script from "./GetCopyForm.vue?vue&type=script&lang=js&"
export * from "./GetCopyForm.vue?vue&type=script&lang=js&"
import style0 from "./GetCopyForm.vue?vue&type=style&index=0&id=519ab3db&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519ab3db",
  null
  
)

export default component.exports